<template>
  <div data-app>
    <v-dialog :value="value" @input="closeModal" :max-width="maxWidth || '600px'" transition="dialog-transition" :persistent="persistent">
      <VCard class="hvh-modal" elevation="3">
        <VCardTitle class="hvh-modal-header">
          <h2>{{ title }}</h2>
          <VSpacer />
          <VIcon color="#000" @click="closeModal" v-if="!propToBool(noClose)">mdi-close</VIcon>
        </VCardTitle>
        <VCardText default class="hvh-modal-body">
          <slot></slot>
        </VCardText>
        <VCardActions class="hvh-modal-footer">
          <VSpacer />
          <slot name="actions"></slot>
        </VCardActions>
      </VCard>
      <Loader v-if="isLoading" />
    </v-dialog>
  </div>
</template>

<script>
import { propToBool } from '../../../libraries/common';
import Loader from '../loader/Loader.vue';
export default {
  components: { Loader },
  props: ['title', 'value', 'maxWidth', 'persistent', 'noClose', 'isLoading'],
  methods: {
    closeModal() {
      this.$emit('input', false);
    },
    propToBool,
  }
}
</script>

<style lang="scss">
.hvh-modal {
  border-radius: 8px;
  font-family: var(--primary-font);
}

.hvh-modal-header {
  background: $color-gray-0;
  border-bottom: 1px solid $color-gray-1;
  padding: rem(20px) rem(30px);
}

.hvh-modal-body {
  padding: rem(20px) rem(30px);
  font-size: rem(16px);
}

.hvh-modal-footer {
  padding: 0 rem(30px) rem(20px);

  .hvh-btn {
    min-width: rem(140px);
  }
}
.v-dialog {
  max-height: 80vh !important;
}
</style>
